import { describeArc } from '../../../util/calculationUtils';
import classes from './Score.module.scss';

interface Props {
  startAngle: number;
  endAngle: number;
  color: string;
}

const ScoreArcLayer = ({ startAngle, endAngle, color }: Props): JSX.Element => {
  return (
    <div className={classes.arcLayer}>
      <svg
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        style={{ overflow: 'visible' }}
      >
        <path
          d={describeArc(50, 50, 40, startAngle, endAngle - 2)}
          className={classes.arcPath}
          stroke={color}
        />
      </svg>
    </div>
  );
};

export default ScoreArcLayer;
